import { FC } from "react";

import { Divider, Stack, Typography } from "@mui/material";

import { MenuNodeType } from "../../model";
import { SubMenuChildNodes } from "../SubMenuChildNodes/SubMenuChildNodes";
import { sharedStyles } from "../shared.styles";

import { menuSectionNodeStyles as styles } from "./MenuSectionNode.styles";

export const MenuSectionNode: FC<{
  node: MenuNodeType.Section;
  isMobile: boolean;
  focus: boolean;
  expansionLinkText?: string;
  containerLinkText?: string;
}> = ({ node, isMobile, expansionLinkText, focus, containerLinkText }) => {
  return (
    <Stack spacing={0}>
      <Stack
        alignItems="baseline"
        flexDirection="row"
        justifyContent="space-between"
        css={[
          node.headerPadding ? styles.headerPadding : styles.header,
          styles.sectionNodeHeader,
          sharedStyles.sectionNodeLabelContainer,
        ]}
      >
        <Typography variant="h2">{node.titleKey}</Typography>
      </Stack>
      <Divider />
      <SubMenuChildNodes
        childNodes={node.childNodes}
        isMobile={isMobile}
        expansionLinkText={expansionLinkText}
        focus={focus}
        containerLinkText={containerLinkText}
      />
    </Stack>
  );
};
